// 演習画面（GazeControl・ShapeChange）共通：誤りモデル名とモチーフモデル名の解決。
// 誤りモデルは親から errorGlbPath（問題指定）で渡され、
// モチーフは誤りモデルに応じて自動選択する（cube系→"cube"、グラス皿系→"model"）。
export function useExerciseModels(errorGlbPathProp) {
  const errorGlbPath = errorGlbPathProp || 'model1';
  const motifGlbPath = errorGlbPath.startsWith('cube') ? 'cube' : 'model';

  return { errorGlbPath, motifGlbPath };
}
